import * as Sentry from "@sentry/vue";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string;

// environnement de l'app enregistré dans ton .env
window.env = import.meta.env.VITE_ENV

export let useSentry = (app: any, router: any) => {
  if (window.env != 'local') {
    Sentry.init({
      app,
      dsn: SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration({router}),
        Sentry.replayIntegration()
      ],
      environment: window.env,
      release: "1.0.0",
      tracesSampleRate: 1.0,
      tracePropagationTargets: ["localhost", /^https:\/\/api\.selftmat\.prep\.digiworks\.fr/, /^https:\/\/mag\.selftmat\.prep\.digiworks\.fr/, /^https:\/\/selftmat\.prep\.digiworks\.fr/, /^https:\/\/api\.selftmat\.fr/, /^https:\/\/mag\.selftmat\.fr/, /^https:\/\/app\.selftmat\.fr/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,

    });
  }
}
